import React from 'react';

import { Email } from '../../components/repositories/Type.jsx';

import {
    BuilderBlock,
    EmptyPlaceholder,
    PageBottomHiddenDraggable,
    PageTopHiddenDraggable
} from './blocks';

import ComponentRegistry from './ComponentRegistry.jsx';
import Name from './Name.jsx';

function GetComponentAndData(block, providedData, context) {
    if (!block || !block.type) {
        return null;
    }
    let data = block;
    let Component;
    const blockType = block.type.value;

    switch (blockType) {
        case Name.Block.Artist.Text:
        case Name.Block.Contact.Image:
        case Name.Block.Contact.Message:
        case Name.Block.Contact.Offer:
        case Name.Block.Contact.Text:
        case Name.Block.Inventory.Button:
        case Name.Block.Inventory.Image:
        case Name.Block.Inventory.Text:
        case Name.Block.Recipient.Text:
        case Name.Block.ResourceText:
            Component = ComponentRegistry.get(blockType);
            data = providedData;
            break;
        case Name.Block.Column:
        case Name.Block.Logo:
            Component = ComponentRegistry.get(blockType);
            data = providedData;
            break;
        case Name.Block.Divider:
        case Name.Block.Footer:
        case Name.Block.HeaderText:
        case Name.Block.Image:
        case Name.Block.LinkButton:
        case Name.Block.Social:
            Component = ComponentRegistry.get(blockType);
            break;
        case Name.Block.Inventory.List:
            switch (context) {
                case Email.value(Email.PurchaseConfirmation):
                case Email.PurchaseConfirmation:
                    Component = ComponentRegistry.get(Name.Block.Inventory.List + '.Transactional');
                    data = providedData && { Inventory: providedData.Inventory };
                    break;
                default:
                    Component = ComponentRegistry.get(Name.Block.Inventory.List + '.Campaign');
                    break;
            }
            break;
        case Name.Block.Text:
        default:
            Component = ComponentRegistry.get(Name.Block.Text);
            break;
    }
    return { component: Component, data };
}

function withBlockRendering(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.handleBlockRendering = this.handleBlockRendering.bind(this);
        }

        handleBlockRendering(blocks, blockPropsHandler, builderBlockPropsHandler) {
            const renderedBlocks = [];
            if (!blocks) {
                return renderedBlocks
            }
            const props = this.props;
            blocks.forEach((d, i) => {
                let componentData = GetComponentAndData(d, props.data, props.pageType);
                if (!componentData || !componentData.component) {
                    return;
                }
                let blockProps = {};
                if (props.onBlockProps) {
                    blockProps = props.onBlockProps(d);
                    if (blockProps.block) {
                        componentData = GetComponentAndData(blockProps.block, props.data, props.pageType);
                    }
                }
                let additionalProps = {};
                if (blockPropsHandler) {
                    additionalProps = blockPropsHandler(d) || {};
                }
                const id = d.id || `${i}`;
                const blockConfig = blockProps.block ? blockProps.block.config : d.config;
                let block = (
                    <componentData.component
                        key={id}
                        active={blockProps.active}
                        baseUrl={props.baseUrl}
                        blockConfig={blockConfig}
                        blockHandler={blockPropsHandler}
                        blockId={id}
                        blocks={blockProps.block ? blockProps.block.blocks : d.blocks}
                        builder={props.builder}
                        builderBlockPropsHandler={builderBlockPropsHandler}
                        config={props.config}
                        data={componentData.data}
                        dataType={d.dataType}
                        disabled={props.disabled}
                        dragging={props.dragging}
                        frameDoc={props.frameDoc}
                        inLayout={props.inLayout}
                        pageConfig={props.pageConfig}
                        queryLayout={props.queryLayout}
                        querySub={props.querySub}
                        serverSide={props.serverSide}
                        type={props.type}
                        onBlockClick={props.onBlockClick}
                        onBlockProps={props.onBlockProps}
                        onDragEnter={props.onDragEnter}
                        onDragStart={props.onDragStart}
                        {...additionalProps} />
                );
                if (props.builder && !props.disabled) {
                    switch (d.dataType) {
                        case 'layout':
                        case 'layout-horizontal':
                        case 'layout-spacer':
                        case 'layout-vertical':
                            break;
                        default:
                            let builderBlockProps = {};
                            if (builderBlockPropsHandler) {
                                builderBlockProps = builderBlockPropsHandler(blockProps.block || d, blockConfig, props) || {};
                            }
                            block = (
                                <BuilderBlock
                                    key={id}
                                    active={blockProps.active}
                                    blockId={id}
                                    blockType={d.type && d.type.value}
                                    builder={props.builder}
                                    dataType={d.dataType}
                                    dragging={props.dragging}
                                    serverSide={props.serverSide}
                                    onBlockClick={props.onBlockClick}
                                    onDragEnter={props.onDragEnter}
                                    onDragStart={props.onDragStart}
                                    {...builderBlockProps}>
                                    {block}
                                </BuilderBlock>
                            );
                            break;
                    }
                }
                renderedBlocks.push(block);
            });
            return renderedBlocks;
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    onBlockRendering={this.handleBlockRendering}>
                    {this.props.children}
                </WrappedComponent>
            );
        }
    }
}

export {
    BuilderBlock,
    EmptyPlaceholder,
    PageBottomHiddenDraggable,
    PageTopHiddenDraggable,
    withBlockRendering
};